import React, { Component } from "react";
import { Form, Card, Row, Col, Input } from "antd";
import ModalFileList from "../../comm/ModalFileList";
import TableFile from "../../comm/TableFile";

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: this.props.data ? this.props.data.files : [],
    };
  }

  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  handleChooseFile = params => {
    this.setState({
      fileList: params,
    });
    this.props.handleChooseFile(params);
  };

  render() {
    const { data, customUuid, showFileTips } = this.props;
    const { getFieldDecorator } = this.props.form;
    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    const { fileList, fileVisible } = this.state;
    return (
      <Card title="合同审核" className="mb16">
        <Row>
          <Col span={20}>
            <FormItem
              label="相关附件"
              {...ItemLayout2}
              style={{ marginBottom: "0" }}
            >
              {customUuid ? (
                <a onClick={() => this.handleFileVisible(true)}>选择附件</a>
              ) : null}
              {showFileTips ? (
                <span style={{ color: "red", paddingLeft: "10px" }}>
                  附件必须上传！
                </span>
              ) : null}
              {fileList.length > 0 ? (
                <TableFile
                  dataSource={fileList}
                  handleChooseFile={this.handleChooseFile}
                />
              ) : null}
            </FormItem>
          </Col>
          <Col span={20} style={{ marginBottom: "16px" }}>
            <Col span={3} />
            <Col span={20}>
              <p style={{ color: "red", whiteSpace: "nowrap" }}>
                若终止申请发生退款和转违约金，请确认相关收入是否已开具发票/收据：
                若已开具请收回原件，并附件上传；
                若原件已丢失，请客户提供丢失证明文件并加盖公章，并附件上传。
              </p>
            </Col>
          </Col>
          <Col span={20}>
            <FormItem label="终止说明" {...ItemLayout2}>
              {getFieldDecorator("reason", {
                rules: [{ required: true, message: "请输入reason!" }],
                initialValue: data ? data.reason : "",
              })(
                <Input.TextArea
                  placeholder="终止说明"
                  type="textarea"
                  autosize={{ minRows: 3, maxRows: 9 }}
                  maxLength={1000}
                />
              )}
              <span style={{ fontSize: "12px", color: "#999" }}>
                *最多可输入1000字
              </span>
            </FormItem>
          </Col>
        </Row>
        {fileVisible ? (
          <ModalFileList
            customUuid={customUuid}
            fileVisible={fileVisible}
            selectedRows={fileList}
            handleCancel={this.handleFileVisible}
            handleChooseFile={this.handleChooseFile}
          />
        ) : null}
      </Card>
    );
  }
}
export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/FormCheck.js